import { PublicKey } from '@solana/web3.js';

interface WhitelistEntry {
  wallet: string;
  wins: number;
  timestamp: number;
}

export class WhitelistService {
  private static REQUIRED_WINS = 3;
  private static API_BASE_URL = '/api/whitelist'; // We'll create these endpoints

  static async addWin(wallet: PublicKey): Promise<boolean> {
    try {
      console.log('Adding win for wallet:', wallet.toString());
      const response = await fetch(`${this.API_BASE_URL}/add-win`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ wallet: wallet.toString() })
      });

      if (!response.ok) {
        throw new Error('Failed to record win');
      }

      const data = await response.json();
      console.log('Win recorded:', data);
      return data.isQualified;
    } catch (error) {
      console.error('Error adding win:', error);
      return false;
    }
  }

  static async getWins(wallet: PublicKey): Promise<number> {
    try {
      console.log('Getting wins for wallet:', wallet.toString());
      const response = await fetch(`${this.API_BASE_URL}/wins/${wallet.toString()}`);
      
      if (!response.ok) {
        throw new Error('Failed to get wins');
      }

      const data = await response.json();
      console.log('Got wins:', data);
      return data.wins;
    } catch (error) {
      console.error('Error getting wins:', error);
      return 0;
    }
  }

  static async isWhitelisted(wallet: PublicKey): Promise<boolean> {
    try {
      console.log('Checking whitelist status for wallet:', wallet.toString());
      const response = await fetch(`${this.API_BASE_URL}/status/${wallet.toString()}`);
      
      if (!response.ok) {
        throw new Error('Failed to check whitelist status');
      }

      const data = await response.json();
      console.log('Whitelist status:', data);
      return data.isWhitelisted;
    } catch (error) {
      console.error('Error checking whitelist status:', error);
      return false;
    }
  }

  static async getSortedLeaderboard(): Promise<WhitelistEntry[]> {
    try {
      console.log('Getting leaderboard');
      const response = await fetch(`${this.API_BASE_URL}/leaderboard`);
      
      if (!response.ok) {
        throw new Error('Failed to get leaderboard');
      }

      const data = await response.json();
      console.log('Got leaderboard:', data);
      return data.entries;
    } catch (error) {
      console.error('Error getting leaderboard:', error);
      return [];
    }
  }
} 